<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="fs-5 fw-bold mb-0">Brands</h1>
  <div class="d-flex gap-2">
    <a [routerLink]="['add']" *isGranted="['ROLE_API_PRODUCT_PRIORITY_WRITE']" class="btn btn-primary fw-bold"><i class="bi bi-plus-lg me-2"></i>Add Brand priority list
  </a>
</div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead>
          <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
            <th tableSorterHeader="id">ID</th>
            <th tableSorterHeader="name">Name</th>
            <th tableSorterHeader="identifier">Identifier</th>
            <th>Brands</th>
            <th>Updated</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (productPriority of productPriorities; track productPriority) {
            <tr>
              <td>{{ productPriority.id }}</td>
              <td>{{ productPriority.name }}</td>
              <td>{{ productPriority.identifier }}</td>
              <td>{{ getSortedProducts(productPriority) }}</td>
              <td>{{ productPriority.updatedAt | date: 'yyyy-MM-dd HH:mm' }}</td>
              <td class="text-center">
                <a class="btn btn-outline-primary btn-sm" [routerLink]="[productPriority.id]"><i class="bi bi-pencil me-1"></i>Edit</a>
                <button *isGranted="['ROLE_API_PRODUCT_PRIORITY_WRITE']" class="btn btn-outline-danger btn-sm ms-1" appConfirm (click)="delete(productPriority)"><i class="bi bi-trash"></i></button>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
    </div>
  </div>
</div>
